module.exports = __webpack_public_path__ + "img/Lot11.4a4e0337.jpg";